import React from "react";
import PropTypes from "prop-types";

function Item({ item, showUsersModal }) {
  return (
    <div className="container_result_statistic_number row">
      <p className="col s3">{item.webinar_title}</p>
      <p className="col s2">
        <span
          className={item.attended_count != 0 && showUsersModal ? "link-style" : ""}
          onClick={() =>
            showUsersModal(item.id, "attended", item.attended_count, {
              id: item.id,
              type: "attended"
            })
          }
        >
          {item.attended_count}
        </span>
      </p>
      <p className="col s2">
        <span
          className={item.views_count != 0 && showUsersModal ? "link-style" : ""}
          onClick={() => showUsersModal(item.id, "viewed", item.views_count, {
              id: item.id,
              type: "viewed"
            })}
        >
          {item.views_count}
        </span>
      </p>
      <p className="col s2">
        <span
          className={item.downloads_count != 0 && showUsersModal ? "link-style" : ""}
          onClick={() =>
            showUsersModal(item.id, "downloaded", item.downloads_count)
          }
        >
          {item.downloads_count}
        </span>
      </p>
      <p className="col s2">
        <span
          className={item.completed_counts != 0 && showUsersModal ? "link-style" : ""}
          onClick={() =>
            showUsersModal(item.id, "completed", item.completed_counts)
          }
        >
          {item.completed_counts}
        </span>
      </p>
      <p className="col s2">
        <span
          className={item.in_person_count != 0 && showUsersModal ? "link-style" : ""}
          onClick={() =>
            showUsersModal(item.id, "attended", item.in_person_count)
          }
        >
          {item.in_person_count}
        </span>
      </p>
    </div>
  );
}

Item.defaultProps = {};

Item.propTypes = {};

export default Item;



// WEBPACK FOOTER //
// ./src/components/Admin/StudyGroups/Statistics/Webinars/Item.jsx